import { Component, Input, OnInit, NgZone, ElementRef, Inject, PLATFORM_ID, Optional, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { timer } from 'rxjs';
import { Request } from 'express';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { PhotoSwipeFigureSlideDownLoadData } from '@techmore/photo-swipe';
import { Detail } from '../../detail';
import { licToAuthorityShortDescription } from '../detail/detail.component';

@Component({
  selector: 'app-download-tooltip',
  templateUrl: './download-tooltip.component.html',
  styleUrls: ['./download-tooltip.component.scss'],
  exportAs: 'downloadTooltip',
})
export class DownloadTooltipComponent implements OnInit, OnChanges {
  /** 是否為開啟中 */
  isOpened = false;
  /** 是否為開啟中 */
  isAnimating = false;
  /** 素材 */
  @Input() data: Detail;
  /** 來源機關的代號 */
  @Input() fetchIndexCode: string;
  /** 當前頁面用來分享的網址 */
  @Input() sharePageUrl: string;
  /** 授權標章圖示 */
  @Input() authorityImg: string;
  /** 授權說明連結 */
  @Input() authorityLink: string;
  /** 授權說明文字 */
  @Input() authorityText: string;
  /** 下載區塊複製授權的文字 */
  downloadRightsCitation: string;
  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  get hostEl() { return this.elRef ? this.elRef.nativeElement as HTMLElement : null; }

  constructor(
    protected zone: NgZone,
    protected elRef: ElementRef,
    @Inject(PLATFORM_ID) protected platformId: object,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected serverConfigService: ServerConfigService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.data && this.fetchIndexCode && this.sharePageUrl && this.authorityImg && this.authorityLink && this.authorityText) {
      const sb: string[] = [];
      switch (this.fetchIndexCode) {
        case 'Culture_Event':
        case 'Culture_Object':
        case 'Culture_Media':
        case 'Culture_Route':
        case 'Culture_Invisible':
          {
            sb.push(this.data.title);
            if (this.data['contributor']) {
              sb.push(`撰寫者：${this.data['contributor']}`);
            }
            if (this.data.contentLic) {
              sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
            }
            if (this.data['createDept']) {
              sb.push(`建檔單位：${this.data['createDept']}`);
            }
            this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${ this.sharePageUrl }`;
          }
          break;
        case 'Culture_People':
        case 'Culture_Organization':
          {
            sb.push(this.data.title);
            if (this.data['creator']) {
              sb.push(`撰寫者：${this.data['creator']}`);
            }
            if (this.data.contentLic) {
              sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
            }
            if (this.data['createDept']) {
              sb.push(`建檔單位：${this.data['createDept']}`);
            }
            this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${ this.sharePageUrl }`;
          }
          break;
        case 'Culture_Place':
          {
            sb.push(this.data.title);
            if (this.data['writer']) {
              sb.push(`撰寫者：${this.data['writer']}`);
            }
            if (this.data.contentLic) {
              sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
            }
            if (this.data['createDept']) {
              sb.push(`建檔單位：${this.data['createDept']}`);
            }
            this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${ this.sharePageUrl }`;
          }
          break;
        default:
          this.downloadRightsCitation = `${ this.data.title ? this.data.title + ' / ' : '' }${ this.data.sourceName ? '授權人：' + this.data.sourceName + ' / ' : '' }${ this.authorityText } @ 國家文化記憶庫 ${ this.sharePageUrl }。`
          break;
      }
    }
  }

  copyCitation() {
    const el = (this.elRef.nativeElement as HTMLElement).querySelector('.tm_pswp-rights-citation');

    if ((document.body as any).createTextRange) { // IE
      const range = (document.body as any).createTextRange();
      range.moveToElementText(el);
      range.select();
      document.execCommand('Copy');
    } else if (window.getSelection) {
      // other browsers
      const range = document.createRange();
      // range.selectNodeContents(elemID);
      range.selectNode(el);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
    }
  }

  open() {
    this.isAnimating = true;
    this.opened.emit();
    timer(250).subscribe(t => {
      this.zone.run(() => {
        this.isAnimating = false;
        this.isOpened = true;
      });
    });
  }

  close() {
    this.isAnimating = true;
    this.closed.emit();
    timer(250).subscribe(t => {
      this.zone.run(() => {
        this.isAnimating = false;
        this.isOpened = false;
      });
    });
  }

  toggle() {
    if (this.isAnimating) { return; }
    if (this.isOpened) {
      this.close();
    } else {
      this.open();
    }
  }
}
